import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular'
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OpsappService {

  api = environment.apiUrl;
  
  headers:any = new HttpHeaders();
  options:any;
  activeIncident: BehaviorSubject<any>;
  activeInstrumentCategory: BehaviorSubject<any>;
  activeInstrument: BehaviorSubject<any>;
  activeWorklist: BehaviorSubject<any>;
  limsToken: BehaviorSubject<any>;

  constructor(private http: HttpClient) { 
    this.activeIncident = new BehaviorSubject<any>(null);
    this.activeInstrumentCategory = new BehaviorSubject<any>(null);
    this.activeInstrument = new BehaviorSubject<any>(null);
    this.activeWorklist = new BehaviorSubject<any>(null);
    this.limsToken = new BehaviorSubject<any>(null);
    //this.headers.append('Content-Type','application/json');
    //this.options = { headers: this.headers };
  }

  getIncidentsList(incidentsOptions: any) {
    return this.http.post<any>(this.api + 'incidents/list', JSON.stringify(incidentsOptions))
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  createIncident(incident:any) {
    return this.http.post<any>(this.api + "incidents/create", JSON.stringify(incident))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  createServiceRequest(service:any) {
    return this.http.post<any>(this.api + "instrument/createservicerequest", JSON.stringify(service))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  getInstruments() {
    return this.http.get<any>(this.api + 'instrument/list')
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getInstrumentServiceCodes(instrumentId: string) {
    return this.http.get<any>(this.api + 'instrument/servicecodes?instrumentId=' + instrumentId)
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  getInstrumentServices(instrumentId: string) {
    return this.http.get<any>(this.api + 'instrument/service?instrumentId=' + instrumentId)
    .toPromise()
    .then(res => <any[]>res)
    .then(data => { return data; });
  }

  addNoteToIncident(note: any){
    return this.http.post<any>(this.api + "incidents/addnote", JSON.stringify(note))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  getOpsDashboard(){
    return this.http.get<any>(this.api + 'dashboard/list')
    .toPromise()
    .then(data => { return data; });
  }

  getInstrumentCategories(){
    return this.http.get<any>(this.api + 'instrument/categories')
    .toPromise()
    .then(data => { return data; });
  }

  getSensors(){
    return this.http.get<any>(this.api + 'sensor/list')
    .toPromise()
    .then(data => { return data; });
  }

  getSensorReading(sensorReadingOptions: any){
    return this.http.post<any>(this.api + 'sensor/readings', JSON.stringify(sensorReadingOptions))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  getWorklistList(worklistListOptions: any){
    return this.http.post<any>(this.api + 'worklist/list', JSON.stringify(worklistListOptions))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  getWorklist(worklistOptions: any){
    return this.http.post<any>(this.api + 'worklist/detail', JSON.stringify(worklistOptions))
    .toPromise()
    .then(data => { return data; });
  }

  getPlateChart(barcode: string){
    return this.http.get<any>(this.api + 'worklist/platechart?barcode=' + barcode)
    .toPromise()
    .then(data => { return data; });
  }

  getRetestReasons(token: string){
    return this.http.post<any>(this.api + 'worklist/retestreasons', JSON.stringify(token))
    .toPromise()
    .then(data => { return data; });
  }

  submitRetest(retestOptions: any){
    return this.http.post<any>(this.api + "worklist/submitretest", JSON.stringify(retestOptions))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  getLimsToken(basicAuthOptions: any){
    return this.http.post<any>(this.api + "auth/limslogin", JSON.stringify(basicAuthOptions))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  getPendingOrders(pendingOrdersOptions: any){
    return this.http.post<any>(this.api + "gure/pendingorders", JSON.stringify(pendingOrdersOptions))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  getPendingPlates(token: string){
    return this.http.post<any>(this.api + "gure/pendingplates", JSON.stringify(token))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  createGoFMX(incident: any){
    return this.http.post<any>(this.api + "gofmx/create", JSON.stringify(incident))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }

  updateGoFMX(instrumentService: any){
    return this.http.post<any>(this.api + "gofmx/update", JSON.stringify(instrumentService))
    .toPromise()
    .then(response => {
        return response as any;
    });
  }


}
